import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from '@/components/ui/toaster';
import {
  useUpdateWorkGroupFolder,
  workgroupsMutationErrorMessage,
} from '@/hooks/use-workgroups';

interface RenameFolderDialogProps {
  workGroupId: string;
  folderId: string;
  folderName: string;
  parentId?: string | null;
  privateAccessReason?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RenameFolderDialog({
  workGroupId,
  folderId,
  folderName,
  parentId,
  privateAccessReason,
  open,
  onOpenChange,
}: RenameFolderDialogProps) {
  const [name, setName] = useState(folderName);
  const mutation = useUpdateWorkGroupFolder();

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast({ title: 'Folder name is required', variant: 'destructive' });
      return;
    }
    mutation.mutate(
      {
        workGroupId,
        folderId,
        name: trimmed,
        parentId,
        privateAccessReason,
      },
      {
        onSuccess: () => {
          toast({ title: 'Folder renamed' });
          onOpenChange(false);
        },
        onError: (err) => {
          toast({ title: workgroupsMutationErrorMessage(err), variant: 'destructive' });
        },
      },
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rename folder</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="rename-folder-name">Name</Label>
          <Input
            id="rename-folder-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="off"
          />
        </div>
        <DialogFooter>
          <Button
            type="button"
            disabled={!name.trim() || mutation.isPending}
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
